export default "__VITE_ASSET__d3c76d6c__"